export const formOrderObjFromCart = (data = null, osType = null, serverType = null, sku = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const dataDisks = data?.itemDetail?.catalogService?.catalogConfig?.diskDefinitions || null;
    const os = data?.itemDetail?.catalogService?.catalogConfig?.os || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;

    const appOwnerLabel =
        entityDetails?.applicationManagerGpid && entityDetails?.applicationManager
            ? `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`
            : null;

    return {
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [{ businessCriticality: catalogConfig?.appBusinessCriticality }],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: entityDetails?.costCenter,
            projectName: entityDetails?.project,
            drRecoveryPriority: environmentDetails?.drPriority,
        },
        tagsQc: { ...catalogConfig?.tags },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        sector: data?.itemDetail?.catalogService?.sector || null,
        billingEntity: data?.itemDetail?.catalogService?.catalogConfig?.billingEntity || null,
        hCode: entityDetails?.costCenter || null,
        ...(entityDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!entityDetails?.costCenter && { hCodeDetails: null }),

        appOwner: appOwnerLabel,
        ...(appOwnerLabel && {
            appOwnerDetails: {
                label: appOwnerLabel,
                gpid: entityDetails?.applicationManagerGpid,
                name: entityDetails?.applicationManager,
                email: entityDetails?.applicationManagerEmail,
            },
        }),
        ...(!appOwnerLabel && { appOwnerDetails: null }),

        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,
        resourceGroup: environmentDetails?.resourceGroup || null,
        resourceGroupDetails: null,
        subscription: environmentDetails?.subscription || null,
        subscriptionDetails: {
            subscriptionId: environmentDetails?.subscriptionId,
            subscriptionName: environmentDetails?.subscription,
        },
        vnetDR: environmentDetails?.virtualNetwork || null,
        vnetDRDetails: environmentDetails?.virtualNetworkId ? { data: { vnetId: environmentDetails?.virtualNetworkId } } : null,
        subnetDR: environmentDetails?.subNetName || null,
        // regionDisplayName: data?.region?.name || null,
        osVersion: os?.publisher ? `${os?.publisher},${os?.sku}` : null,
        // osVersionDetail: data?.osType || null,
        osType: os?.osType,
        nvmeSupport: catalogConfig?.nvmeSupport === true ? 'yes' : 'no',
        migratingDBRadio: catalogConfig?.migratePre19cDB === true ? 'yes' : 'no',
        catalogSize: catalogConfig?.catalogSize,
        sku,
        vmType: data?.itemDetail?.catalogService?.catalogConfig?.vmType || null,
        dataDisksCount: dataDisks?.length || 0,
        dataDisks:
            dataDisks?.map((item) => ({
                // eslint-disable-next-line
                diskType: item?.diskType ? item?.diskType : ['Production'].includes(environmentDetails?.environment) ? 'Premium SSD' : 'Standard SSD',
                diskDriveLetter: item?.diskDriveLetter,
                mountPoint: item?.mountPoint,
                // eslint-disable-next-line
                fsType: item?.fsType ? item?.fsType : os?.osType === 'Windows' ? 'NTFS' : 'ext4',
                diskSizeInGib: item?.diskSizeInGib,
            })) || [],
        expDBSize: Number(catalogConfig?.dbSize) || 0,
        databaseName: catalogConfig?.dbName,
        dbCharacterSet: catalogConfig?.dbCharacterSet,
        dbNationalCharSet: catalogConfig?.dbNationalCharSet,
        oracleVersion: catalogConfig?.oracleVersion,
        domain: environmentDetails?.domain || null,
        // domainDetail: data?.domain || null,
        adousDefault: environmentDetails?.adOu || 'Default OU',
        ...(osType === 'Windows' && { adGroup: data?.itemDetail?.catalogService?.catalogConfig?.adGroup || '' }),
        ...(osType === 'Linux' && { samAccountId: data?.itemDetail?.catalogService?.catalogConfig?.samAccountId || '' }),
        ...(environmentDetails?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: environmentDetails?.availabilityZones,
            availabilityZoneOptions: environmentDetails?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(environmentDetails?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        ...(environmentDetails?.environment === 'Production' && {
            azureSiteRecovery: catalogConfig?.azureSiteRecovery ? 'yes' : 'no',
        }),
        oracleId: catalogConfig?.oracleId || null,
        quantity: data?.itemDetail?.catalogService?.quantity,
        timeZone: data?.itemDetail?.catalogService?.timeZone,
        acceleratedNetworking: catalogConfig?.acceleratedNetworking === true ? 'yes' : 'no',
        serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no',
        ...(environmentDetails?.environment === 'Production' && {
            azureSiteRecovery: catalogConfig?.azureSiteRecovery ? 'yes' : 'no',
        }),
        serverType,
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null, osType = null, serverType = null, sku = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const dataDisks = catalogConfig?.diskDefinitions || null;
    const os = catalogConfig?.os || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;

    const appOwnerLabel =
        entityDetails?.applicationManagerGpid && entityDetails?.applicationManager
            ? `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`
            : null;

    return {
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [{ businessCriticality: catalogConfig?.appBusinessCriticality }],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: environmentDetails?.costCenter,
            projectName: environmentDetails?.projectName,
            billingEntity: catalogConfig?.billingEntity,
            sector: catalog?.sector,
            drRecoveryPriority: environmentDetails?.drPriority,
        },
        tagsQc: { ...catalogConfig?.tags },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        sector: catalog?.sector || null,
        billingEntity: catalogConfig?.billingEntity || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),

        appOwner: appOwnerLabel,
        ...(appOwnerLabel && {
            appOwnerDetails: {
                label: appOwnerLabel,
                gpid: entityDetails?.applicationManagerGpid,
                name: entityDetails?.applicationManager,
                email: entityDetails?.applicationManagerEmail,
            },
        }),
        ...(!appOwnerLabel && { appOwnerDetails: null }),

        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,
        resourceGroup: environmentDetails?.resourceGroup || null,
        resourceGroupDetails: null,
        subscription: environmentDetails?.subscription || null,
        subscriptionDetails: {
            subscriptionId: environmentDetails?.subscriptionId,
            subscriptionName: environmentDetails?.subscription,
        },
        vnetDR: environmentDetails?.virtualNetwork || null,
        vnetDRDetails: environmentDetails?.virtualNetworkId ? { data: { vnetId: environmentDetails?.virtualNetworkId } } : null,
        subnetDR: environmentDetails?.subNetName || null,
        // regionDisplayName: data?.region?.name || null,
        osVersion: os?.publisher ? `${os?.publisher},${os?.sku}` : null,
        // osVersionDetail: data?.osType || null,
        osType: os?.osType,
        sku,
        vmType: catalogConfig?.vmType || null,
        nvmeSupport: catalogConfig?.nvmeSupport === true ? 'yes' : 'no',
        migratingDBRadio: catalogConfig?.migratePre19cDB === true ? 'yes' : 'no',
        catalogSize: catalogConfig?.catalogSize,
        dataDisksCount: dataDisks?.length || 0,
        dataDisks:
            dataDisks?.map((item) => ({
                // eslint-disable-next-line
                diskType: item?.diskType ? item?.diskType : ['Production'].includes(environmentDetails?.environment) ? 'Premium SSD' : 'Standard SSD',
                diskDriveLetter: item?.diskDriveLetter,
                mountPoint: item?.mountPoint,
                // eslint-disable-next-line
                fsType: item?.fsType ? item?.fsType : os?.osType === 'Windows' ? 'NTFS' : 'ext4',
                diskSizeInGib: item?.diskSizeInGib,
            })) || [],
        expDBSize: Number(catalogConfig?.dbSize) || 0,
        databaseName: catalogConfig?.dbName,
        dbCharacterSet: catalogConfig?.dbCharacterSet,
        dbNationalCharSet: catalogConfig?.dbNationalCharSet,
        oracleVersion: catalogConfig?.oracleVersion,
        domain: environmentDetails?.domain || null,
        // domainDetail: data?.domain || null,
        adousDefault: environmentDetails?.adOu || 'Default OU',
        ...(osType === 'Windows' && { adGroup: catalogConfig?.adGroup || '' }),
        ...(osType === 'Linux' && { samAccountId: catalogConfig?.samAccountId || '' }),
        ...(environmentDetails?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: environmentDetails?.availabilityZones,
            availabilityZoneOptions: environmentDetails?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(environmentDetails?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        ...(environmentDetails?.environment === 'Production' && {
            azureSiteRecovery: catalogConfig?.azureSiteRecovery ? 'yes' : 'no',
        }),
        oracleId: catalogConfig?.oracleId || null,
        acceleratedNetworking: catalogConfig?.acceleratedNetworking === true ? 'yes' : 'no',
        serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no',
        ...(environmentDetails?.environment === 'Production' && {
            azureSiteRecovery: catalogConfig?.azureSiteRecovery ? 'yes' : 'no',
        }),
        quantity: catalog?.quantity,
        timeZone: catalog?.timeZone,
        serverType,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time cost',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'per item per month',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};
export const resetOrder = {
    appProfile: null,
    appProfileDetails: null,
    appOwner: null,
    appOwnerDetails: null,
    entityDetails: null,
    microService: null,
    microServiceDetails: null,
    microServiceOptionsAvailable: null,
    businessCategory: null,
    environment: null,
    appTier: null,
    appTierCode: null,
    region: null,
    regionDisplayName: null,
    landingZone: null,
    landingZoneDetails: null,
    envDetails: null,
    osVersion: null,
    osDiskType: null,
    vmType: null,
    vmTypeDetails: null,
    quantity: 1,
    maxDataDiskCount: null,
    dataDisksCount: null,
    dataDisks: [],
    defaultDataDisks: [],
    adGroup: null,
    hoursOfOperation: null,
    hoursOfOperationDetail: null, // { active: 1, id: '763cf923-85d9-43f7-b338-7be17fded399', name: 'Always ON', type: 'hours_of_operation' },
    timeZone: 'UTC',
    timeZoneDetail: null, // { id: 'd3bb59b6-72b3-49c0-a1c2-c0494ea28802', name: 'UTC', type: 'time_zones', value: 'Default-UTC' }
    domain: null,
    domainDetails: null,
    hCode: null,
    hCodeDetails: null,
    billingEntity: null,
    billingEntityDetails: null,
    adousDefault: null,
    adous: null,
    adousDetails: null,
    sector: null,
    sectorDetails: null,
    resourceGroup: null,
    resourceGroupDetails: null,
    subscription: null,
    subscriptionDetails: null,
    vnetDR: null,
    vnetDRDetails: null,
    subnetDR: null,
    subnetDRDetails: null,
    tags: [],
    tagsQc: null,
    estimatedCost: resetCostEstimateDetails,
    oracleId: null,
    acceleratedNetworking: 'yes',
    serverRefresh: 'no',
    validationStatus: 'clearValidation',
    isTouched: false,
    haDeployment: null,
    availabilityZone: null,
    availabilityZoneOptions: [],
    retiringServerName: null,
    retiringServerSysId: null,
    disposalReason: null,
    scheduledRetirement: null,
    expDBSize: '',
    databaseName: '',
    samAccountId: null,
    samAccountIdDetails: null,
    dbCharacterSet: null,
    dbNationalCharSet: null,
    nvmeSupport: 'no',
    migratingDBRadio: 'no',
    catalogSize: null,
    azureSiteRecovery: 'no',
};

export const resetForQuickConfig = {
    environment: null,
    appTier: null,
    appTierCode: null,
    region: null,
    regionDisplayName: null,
    landingZone: null,
    landingZoneDetails: null,
    osVersion: null,
    osVersionDetail: null,
    vmType: null,
    vmTypeDetails: null,
    dataDisksCount: 0,
    dataDisks: [],
    domain: null,
    domainDetail: null,
    adousDefault: null,
    expDBSize: null,
    haDeployment: null,
    envDetails: null,
    availabilityZone: null,
    availabilityZoneOptions: [],
    databaseName: '',
    dbCharacterSet: null,
    dbNationalCharSet: null,
    oracleId: null,
};

export const restEnv = {
    Subscription: '-',
    'DR Priority': '-',
    Resource_Group: '-',
    Metallic_Selection: '-',
    Backup_Tier: '-',
    Virtual_Network: '-',
    // Network_Security_Group: '-',
    Subnet_Name: '-',
    // Application_Security_Group: '-',
    // Recovery_Vault_Name: '-',
    Approval_Manager: '-',
    Project: '-',
    Availability_Set: '-',
};
export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
};

export const getSku = (order) => {
    let s = '';
    order?.sku?.map((item) => {
        if (order?.nvmeSupport === 'yes' && item?.includes('NVME')) {
            s = item;
        } else if (order?.nvmeSupport !== 'yes' && !item?.includes('NVME')) {
            s = item;
        }
        return '';
    });
    return s;
};
export const validsize = {
    'Small(0TB-1TB)': { min: 0, max: 1024 },
    'Medium(1TB-5TB)': { min: 1024, max: 5120 },
    'Large(5TB-10TB)': { min: 5120, max: 10240 },
    'X-Large(>10TB)': { min: 10240, max: 51200 },
};
